import { Container, Row } from "reactstrap";
import ButtonAddons from "./ButtonAddons";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, InputGroupTitle } from "../../../../../Constants/Constants";
import CustomForms from './CustomForms/CustomForms'
import CustomFileInput from './CustomFileInput'
import ButtonsWithDropdowns from './ButtonsWithDropdowns/ButtonsWithDropdowns'
import SegmentedButtons from './SegmentedButtons'
import CheckboxesAndRadios from './CheckboxesAndRadios'
import Sizing from './Sizing'
import MultipleInputs from './MultipleInputs'
import BasicInputGroups from './BasicInputGroups'
import VariationAddons from './VariationAddons/VariationAddons'
import { Fragment } from "react/jsx-runtime";

const InputGroupsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={InputGroupTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <ButtonAddons />
          <CustomForms/>
          <CustomFileInput/>
          <ButtonsWithDropdowns/>
          <SegmentedButtons/>
          <CheckboxesAndRadios/>
          <Sizing/>
          <MultipleInputs/>
          <BasicInputGroups/>
          <VariationAddons/>
        </Row>
      </Container>
    </Fragment>
  );
};
export default InputGroupsContainer;
